import { render, staticRenderFns } from "./mod3-1.vue?vue&type=template&id=4b205e6b&scoped=true&"
import script from "./mod3-1.vue?vue&type=script&lang=js&"
export * from "./mod3-1.vue?vue&type=script&lang=js&"
import style0 from "./mod3-1.vue?vue&type=style&index=0&id=4b205e6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b205e6b",
  null
  
)

export default component.exports